// Display-only grade mapping — no proprietary logic.
// Mirrors the backend ladder in compute_grades.js getGradeLetter(): btts and
// draw collapse the B band into C (their B rung is not validated). Always
// prefer the backend-computed `grade_letter` when present — pass it as
// `storedLetter`; the score-based mapping is only a fallback for rows graded
// before grade_letter existed.
const GRADE_STYLES = {
  'A+': { color: 'text-emerald-400', bg: 'bg-emerald-500/20' },
  'A':  { color: 'text-green-400',   bg: 'bg-green-500/20' },
  'B':  { color: 'text-yellow-400',  bg: 'bg-yellow-500/20' },
  'C':  { color: 'text-orange-400',  bg: 'bg-orange-500/20' },
  'D':  { color: 'text-red-400',     bg: 'bg-red-500/20' },
};

export function getGradeLetter(score, type) {
  if (score >= 90) return 'A+';
  if (score >= 80) return 'A';
  if (type === 'btts' || type === 'draw') return score >= 60 ? 'C' : 'D';
  if (score >= 70) return 'B';
  if (score >= 60) return 'C';
  return 'D';
}

export function getGradeInfo(score, type, storedLetter) {
  const letter = (storedLetter && GRADE_STYLES[storedLetter]) ? storedLetter
    : getGradeLetter(score, type);
  return { letter, ...GRADE_STYLES[letter] };
}
